import { create } from 'zustand';
import { useErrorStore } from './useErrorStore';

const BLOCKED_SESSION_CODE = 'NOT_ACTIVE_OR_NO_RECHARGE';
const BLOCKED_SESSION_MESSAGE = 'Usuário não ativo ou não possui recarga';

export const useSessionStore = create((set, get) => ({
  logoutHandler: null,
  isInvalidatingSession: false,
  invalidationReason: null,

  setLogoutHandler: (handler) => set({ logoutHandler: handler }),

  resetSessionInvalidation: () => set({
    isInvalidatingSession: false,
    invalidationReason: null,
  }),

  handleBlockedSession: (payload = {}) => {
    const { code } = payload;

    if (code !== BLOCKED_SESSION_CODE) {
      return false;
    }

    const { isInvalidatingSession, logoutHandler } = get();

    useErrorStore.getState().setErrorMessage(
      BLOCKED_SESSION_MESSAGE,
      { force: true, lock: true },
    );

    if (!isInvalidatingSession) {
      set({
        isInvalidatingSession: true,
        invalidationReason: code,
      });

      Promise.resolve(logoutHandler?.()).catch(() => {});
    }

    return true;
  },
}));
